"use client";
import React, { useState } from "react";

import SingleSelect from "app/(new-pages)/components/allSelect/baseSelect/pc/SingleSelect";
import LocationSelectPc from "app/(new-pages)/components/allSelect/LocationSelect/pc";

import styles from "../../../style/index.module.scss";
import LanguageSelectPc from "app/(new-pages)/components/allSelect/LanguageSelect/pc";
import { ClearAllIcon, MoreIcon } from "../assets/icon";
import JobFunctionSelectPc from "app/(new-pages)/components/allSelect/JobFunctionSelect/pc";
import BenefitsSelectPc from "app/(new-pages)/components/allSelect/BenefitsSelect/pc";
import classNames from "classnames";
import DrawerFilter from "app/(new-pages)/components/DrawerFilter";

const FiltersInHeader = ({
  config,
  sortFilter,
  locationValue,
  setLocationValue,
  jobFunction,
  setJobFunction,
  language,
  setLanguage,
  handleClearAll,
  sort,
  setSort,
  handleSortReset,
  benefits,
  setBenefits,
  moreFilterData,
  setMoreFilterData,
  selectCount,
  setSelectCount,
  rooterStyle
}) => {
  const {
    main_function_filter,
    language_filter,
    location_filter,
    sorted_by_text,
    location_text,
    main_function_text,
    language_text,
    clear_all_text,
    remote_only_text,
    clear_text,
    search_country_text,
    search_job_function_text,
    apply_filters_text,
    benefits_text,
    benefits_filter,
    more_filter_text,

    job_type_text,
    job_type_filter,
    xp_lvl_text,
    xp_lvl_filter,
    degree_text,
    degree_filter,
    company_size_text,
    company_size_filter,
    financing_stage_text,
    financing_stage_filter,
    clear_filter_text,
    filter_apply_text,
    filter_header_text
  } = config;

  const [open, setOpen] = useState(false);

  const onClose = () => {
    setOpen(false);
  };

  const onConfirm = (ev) => {
    setMoreFilterData({
      company_financing_stage: ev.company_financing_stage ? ev.company_financing_stage : "",
      company_size: ev.company_size ? ev.company_size : "",
      degree: ev.degree ? ev.degree : "",
      job_type: ev.job_type ? ev.job_type : "",
      xp_lvl: ev.xp_lvl ? ev.xp_lvl : ""
    });
  };

  const openMoreFilter = () => {
    setOpen(true);
  };

  return (
    <>
      <div style={rooterStyle} className={classNames(styles.filterContainer, "yolo-filter-warp")}>
        <div className={styles.fields}>
          <div className={styles.single}>
            <div className={styles.singleField}>
              <SingleSelect
                className={styles.singleOverrideSelect}
                options={sortFilter}
                variant='borderless'
                value={sort}
                onChange={setSort}
                onReset={handleSortReset}
                clear_text={clear_text}
                showReset={false}
              />
            </div>
          </div>

          <div className={styles.multiple}>
            <div className={styles.field}>
              <LocationSelectPc
                label={location_text}
                location_filter={location_filter}
                value={locationValue}
                onChange={setLocationValue}
                //
                searchBoardPlaceholder={search_country_text}
                boardClearText={clear_text}
                boardApplyFiltersText={apply_filters_text}
              />
            </div>

            <div className={styles.field}>
              <JobFunctionSelectPc
                label={main_function_text}
                main_function_filter={main_function_filter}
                value={jobFunction}
                onChange={setJobFunction}
                searchBoardPlaceholder={search_job_function_text}
              />
            </div>

            <div className={styles.field}>
              <LanguageSelectPc
                label={language_text}
                language_filter={language_filter}
                value={language}
                onChange={setLanguage}
                //
                boardClearText={clear_text}
                boardApplyFiltersText={apply_filters_text}
              />
            </div>

            <div className={styles.field}>
              <BenefitsSelectPc
                label={benefits_text}
                benefits_filter={benefits_filter}
                value={benefits}
                onChange={setBenefits}
              />
            </div>

            <div className={classNames([styles.field, styles.moreFiled])} onClick={openMoreFilter}>
              {more_filter_text}

              {selectCount > 0 ? <span className={styles.field_count}>{selectCount}</span> : null}
              <MoreIcon />
            </div>
          </div>
        </div>

        <div className={styles.clearAll} onClick={handleClearAll} title={clear_all_text}>
          <ClearAllIcon />
        </div>
      </div>

      <DrawerFilter
        data={{
          job_type_text,
          job_type_filter,
          xp_lvl_text,
          xp_lvl_filter,
          degree_text,
          degree_filter,
          company_size_text,
          company_size_filter,
          financing_stage_text,
          financing_stage_filter,
          clear_filter_text,
          apply_filter_text: filter_apply_text,
          filter_header_text
        }}
        open={open}
        onClose={onClose}
        hideMenu={true}
        onConfirm={onConfirm}
        value={moreFilterData}
        setSelectCount={setSelectCount}
      />
    </>
  );
};

export default FiltersInHeader;
